import { render, staticRenderFns } from "./managementDetail.vue?vue&type=template&id=62430d37&scoped=true&"
import script from "./managementDetail.vue?vue&type=script&lang=ts&"
export * from "./managementDetail.vue?vue&type=script&lang=ts&"
import style0 from "./managementDetail.vue?vue&type=style&index=0&id=62430d37&lang=scss&scoped=true&"
import style1 from "./managementDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62430d37",
  null
  
)

export default component.exports